import { render, staticRenderFns } from "./PDA_Allocated.vue?vue&type=template&id=19bfc0dd"
import script from "./PDA_Allocated.vue?vue&type=script&lang=js"
export * from "./PDA_Allocated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports